<ion-content fullscreen>
  <app-auth-template [title]="loginProps.login">
    <form
      #login="ngForm"
      (ngSubmit)="onLogin(login, resendEmailTemplate)">
      <ion-item-group class="p-4">

        <!-- EMAIL -->
        <ion-item
          class="radius-4 mt-6"
          lines="full"
          [class.error]="(email.dirty || email.touched) && email.errors">
          <ion-input
            #email="ngModel"
            type="email"
            placeholder="Email"
            name="email"
            required
            email
            ngModel
            (keydown.enter)="focusAndClickLoginButton()">
          </ion-input>
          <ion-button
            fill="clear"
            slot="end"
            (click)="email.reset()">
            <ion-icon name="close-outline">
            </ion-icon>
          </ion-button>
        </ion-item>
        <div
          *ngIf="(email.dirty || email.touched) && email.errors"
          class="text-red-500 body-3 mt-1 ml-1 pos-abs">
          <span *ngIf="email.errors?.required">
            {{ loginProps.emailRequired }}
          </span>
          <span *ngIf="email.errors?.email">
            {{ loginProps.emailInvalid }}
          </span>
        </div>

        <!-- PASSWORD -->
        <ng-container *ngIf="{ value: false } as showPassword">
          <ion-item
            class="radius-4 mt-6"
            lines="full"
            [class.error]="(password.dirty || password.touched) && password.errors">
            <ion-input
              #password="ngModel"
              [type]="showPassword.value ? 'text' : 'password'"
              placeholder="Password"
              name="password"
              required
              ngModel
              (keydown.enter)="focusAndClickLoginButton()">
            </ion-input>
            <div slot="end" class="fx-row">
              <ion-button
                fill="clear"
                slot="icon"
                (click)="showPassword.value = !showPassword.value">
                <ion-icon [name]="showPassword.value ? 'eye' : 'eye-off'">
                </ion-icon>
              </ion-button>
              <ion-button
                fill="clear"
                slot="icon"
                (click)="password.reset()">
                <ion-icon name="close-outline">
                </ion-icon>
              </ion-button>
            </div>
          </ion-item>
          <div
            *ngIf="(password.dirty || password.touched) && password.errors"
            class="text-red-500 body-3 mt-1 ml-1 pos-abs">
            <span *ngIf="password.errors?.required">
              {{ loginProps.passwordRequired }}
            </span>
          </div>
        </ng-container>

      </ion-item-group>
      <ion-button
        #loginButton
        class="mx-3 mb-2 ion-button-grey"
        expand="block"
        type="submit"
        [disabled]="login.invalid || login.pending">
        {{ loginProps.login }}
      </ion-button>
      <ion-button
        class="mx-3 mb-2 text-grey-500"
        expand="block"
        fill="clear"
        [replaceUrl]="true"
        [routerLink]="['../forgot-password']">
        {{ loginProps.forgotPassword }}
      </ion-button>
      <ion-button
        class="mx-3 mb-2 text-grey-500"
        expand="block"
        fill="clear"
        [replaceUrl]="true"
        [routerLink]="['../register']">
        {{ loginProps.signUp }}
      </ion-button>
      <ng-content select="[anotherSignUps]"></ng-content>
    </form>
  </app-auth-template>
</ion-content>

<ng-template #resendEmailTemplate>
  <div class="fx-col fx-justify-center fx-align-center pos-rel p-3">
    <ion-button
      class="pos-abs inset-r-3 inset-t-0"
      fill="clear"
      (click)="popoverController.dismiss()">
      <ion-icon
        class="s-6"
        name="close-outline">
      </ion-icon>
    </ion-button>
    <div class="h3 text-uppercase text-accent text-bold">
      Welcome
    </div>
    <div class="fx-col w-full fx-justify-center mt-8">
      <div class="fx-row fx-align-center">
        <ion-icon
          class="s-6 mr-3"
          color="warning"
          name="alert-circle">
        </ion-icon>
        <div class="body-1 text-capitalize text-accent text-bold">
          Email verification
        </div>
      </div>
      <div class="body-1 text-grey-500 mx-6 text-justify mt-8">
        Thanks for signing up! we just need you to verify your email address to complete setting up your account.
      </div>
      <ion-button
        class="mx-3 mt-8 ion-button-grey"
        expand="block"
        (click)="resendEmailVerification();">
        Resend Email
      </ion-button>
    </div>
  </div>
</ng-template>
